import { createApp } from 'vue'
import SettingsPage from '../components/SettingsPage.vue'

export function mountSettings() {
  const el = document.getElementById('settings-app')
  if (!el) return
  createApp(SettingsPage, { dialect: el.dataset.dialect || 'south' }).mount(el)
}
